var _path, _rect, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTerminalsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24023 15.689V9.69707C1.24023 9.03433 1.77749 8.49707 2.44023 8.49707H13.496C14.1588 8.49707 14.696 9.03433 14.696 9.69707V15.689",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.80844,
    y: 12.2537,
    width: 2.51013,
    height: 1.19412,
    rx: 0.597058,
    strokeWidth: 0.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33594 10.3941C2.33594 10.0497 2.61512 9.77051 2.95952 9.77051H12.7448C13.0892 9.77051 13.3684 10.0497 13.3684 10.3941C13.3684 10.7385 13.0892 11.0177 12.7448 11.0177H2.95952C2.61512 11.0177 2.33594 10.7385 2.33594 10.3941Z",
    fill: "#5466F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.80844,
    y: 14.6034,
    width: 2.51013,
    height: 1.19412,
    rx: 0.597058,
    strokeWidth: 0.32
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.57406,
    y: 12.2537,
    width: 2.51013,
    height: 1.19412,
    rx: 0.597058,
    strokeWidth: 0.32
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.57406,
    y: 14.6034,
    width: 2.51013,
    height: 1.19412,
    rx: 0.597058,
    strokeWidth: 0.32
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3397,
    y: 12.2537,
    width: 2.51013,
    height: 1.19412,
    rx: 0.597058,
    strokeWidth: 0.32
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3397,
    y: 14.6034,
    width: 2.51013,
    height: 1.19412,
    rx: 0.597058,
    strokeWidth: 0.32
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61719 3.49365V9.99192C3.61719 10.302 3.86854 10.5533 4.17861 10.5533H11.7558C12.0658 10.5533 12.3172 10.302 12.3172 9.99192V3.2994C12.3172 3.03763 12.0213 2.88543 11.8083 3.03768C11.6964 3.11771 11.546 3.11771 11.4341 3.03768L11.2517 2.90732C11.0564 2.76767 10.794 2.76767 10.5987 2.90732L10.5557 2.938C10.3604 3.07764 10.098 3.07764 9.90266 2.938L9.85974 2.90732C9.66444 2.76767 9.40196 2.76767 9.20666 2.90732L9.16375 2.938C8.96844 3.07764 8.70596 3.07764 8.51066 2.938L8.46775 2.90732C8.27245 2.76767 8.00996 2.76767 7.81466 2.90732L7.77175 2.938C7.57645 3.07764 7.31396 3.07764 7.11866 2.938L7.07575 2.90732C6.88045 2.76767 6.61796 2.76767 6.42266 2.90732L6.35588 2.95507C6.17241 3.08625 5.92826 3.09491 5.73596 2.97705L5.58531 2.88472C5.38023 2.75903 5.11748 2.78 4.93493 2.93664L4.91679 2.95219C4.76142 3.08551 4.54204 3.11468 4.35723 3.02658C4.01386 2.86291 3.61719 3.11326 3.61719 3.49365Z",
    fill: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0293 6.5884L7.48271 8.00722L9.90497 5.51562",
    strokeWidth: 0.648031,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalsIcon);
export default __webpack_public_path__ + "static/media/terminalsIcon.a079d681.svg";
export { ForwardRef as ReactComponent };